// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2319":"a4705bb1","3920":"2a4e6361"}[chunkId] + ".chunk.css";
};